import React from 'react';
import './Menu.css'; // Import your Menu CSS if needed

const Menu = () => {
    console.log("Menu component rendered"); // Debugging line
    return (
        <nav className="menu">
            <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/products">Products</a></li>
                <li><a href="/cart">Cart</a></li>
                <li><a href="/checkout">Checkout</a></li>
            </ul>
        </nav>
    );
};

export default Menu;
